import { useParams } from 'react-router-dom';

import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import useFetchEventOverviewStats, { EStatKeys } from '../helpers/use-fetch-event-overview-stats';
import { getPublishedStatus } from '@/store/slices/project/selectors';
import { useAppSelector } from '@/store/hooks';
import { EProjectStatus } from '@/types/projects.types';
import StatsCard from '../components/stats-card';
import { useIsLoadingStat } from '../helpers/use-is-loading-stat';
import useGetStatsIconColors from '../helpers/use-get-stats-icon-colors';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';

const WebinarStats = () => {
  const params = useParams();
  const language = params?.language || 'en';
  const projectUuid = params?.projectUuid || '';

  /* TODO: update this to use ondemand stats. See figma: https://www.figma.com/design/xq2Pwf0fOxO0vp1AC2vpLD/Platform-%E2%80%A2-Feature---Updates--2?node-id=1020-21164&p=f&m=dev */
  const { data } = useFetchEventOverviewStats({
    projectUuid,
    language,
    stats: [
      EStatKeys.invites,
      EStatKeys.registrations,
      EStatKeys.uniqueAttendees,
      EStatKeys.avgUserWatchtime,
      EStatKeys.averageProjectRating,
      EStatKeys.shares,
    ],
  });

  const publishedStatus = useAppSelector(getPublishedStatus);

  const isPublished = publishedStatus?.status === EProjectStatus.PUBLIC;

  const isLoadingStat = useIsLoadingStat(data, isPublished);

  const statsColors = useGetStatsIconColors();

  return (
    <Container data-component="WebinarStats" className="padding-t-8" maxWidth="392px">
      <Container className="margin-b-8">
        <Text tag="h5" className="H5" design="GlobalIcoText1">
          Stats
        </Text>
      </Container>
      <Container className="flex fd-row fw-wrap jc-flex-start ai-center gap-8">
        <StatsCard
          loading={isLoadingStat(EStatKeys.invites)}
          title="Invited"
          tooltip="Unique users who have registered for this event."
          value={isPublished ? (data[EStatKeys.invites]?.value ?? -1) : -1}
          subvalue={data[EStatKeys.registrations]?.subValue}
          Icon={<Icon name={ICONS.RESEND_EMAIL} color={statsColors.from} size={16} />}
        />
        <StatsCard
          loading={isLoadingStat(EStatKeys.registrations)}
          title="Registered"
          tooltip="Unique users who have registered for this event."
          value={isPublished ? (data[EStatKeys.registrations]?.value ?? -1) : -1}
          subvalue={data[EStatKeys.registrations]?.subValue}
          Icon={<Icon name={ICONS.REGISTERED} color={statsColors.from} size={16} />}
        />
        <StatsCard
          loading={isLoadingStat(EStatKeys.shares)}
          title="Shares"
          tooltip="Total unique shares per session per user"
          value={isPublished ? (data[EStatKeys.shares]?.value ?? -1) : -1}
          Icon={<Icon name={ICONS.ARROW_BIG_TURN_RIGHT} color={statsColors.from} size={16} />}
        />
      </Container>
    </Container>
  );
};

export default WebinarStats;
